// Detect Zebra / Honeywell / Datalogic ruggedized scanners by user-agent.
// Used by PortaLetterePage to choose the best default scan mode (laser vs
// camera) on first launch. The user can always override and we remember
// their choice in localStorage.
//
// References (substrings consistently present in stock Android browser UA):
//   • Zebra TC27 / TC52 / TC57 / TC72 / TC77: "TC27", "TC52", "TC57", "TC72", "TC77", or the umbrella "Zebra"
//   • Honeywell EDA51 / CT40 / CN80: "Honeywell" or "EDA51", "CT40", "CN80"
//   • Datalogic Memor / Skorpio: "Datalogic", "Memor", "Skorpio"

const ZEBRA_RE = /TC2[57]|TC5[27]|TC7[27]|Zebra/i;
const HONEYWELL_RE = /Honeywell|EDA51|CT40|CN80/i;
const DATALOGIC_RE = /Datalogic|Memor|Skorpio/i;

export function isRuggedScannerDevice(ua) {
  const s = (ua || (typeof navigator !== 'undefined' ? navigator.userAgent : '') || '');
  return ZEBRA_RE.test(s) || HONEYWELL_RE.test(s) || DATALOGIC_RE.test(s);
}

export function ruggedDeviceFamily(ua) {
  const s = (ua || (typeof navigator !== 'undefined' ? navigator.userAgent : '') || '');
  if (ZEBRA_RE.test(s)) return 'zebra';
  if (HONEYWELL_RE.test(s)) return 'honeywell';
  if (DATALOGIC_RE.test(s)) return 'datalogic';
  return null;
}
